import request from '@/sheep/request';

export interface LimitProjectShare {
	id ?: number
	projectId ?: number
	code ?: string
	title ?: string
	content ?: string
	sort ?: number
	status ?: number
	createTime ?: any
}

// 随机获得自律项分享标题（projectId 和 code 满足其一即可）
export const getRandomLimitProjectShare = async (params ?: { projectId ?: number; code ?: string }) => {
	return request({
		url: '/wish/limit-project-share/random',
		method: 'GET',
		params,
		custom: {
			auth: false,
			isToken: false
		}
	});
}
